import { useHasAccess } from 'lib-shared-access-control';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { NotFoundView } from '../../../notFound';

import { SettingsAgentsView } from './settingsAgents.view';
import { SettingsAwayStatusView } from './views/awayStatus/settingsAwayStatus.view';
import { SettingsAgentsListView } from './views/list/settingsAgentsList.view';
import { SettingsAgentsRolesView } from './views/roles/settingsAgentsRoles.view';
import { SettingsAgentsRolesCreateView } from './views/roles/views/create/settingsAgentsRolesCreate.view';
import { SettingsAgentsRolesEditView } from './views/roles/views/edit/settingsAgentsRolesEdit.view';
import { SettingsAgentsRolesEditAgentsView } from './views/roles/views/edit/views/agents/settingsAgentsRolesEditAgents.view';
import { SettingsAgentsRolesEditPermissionsView } from './views/roles/views/edit/views/permissions/settingsAgentsRolesEditPermissions.view';
import { SettingsAgentsWorkloadsView } from './views/workloads/settingsAgentsWorkloads.view';

export const SettingsAgentsRoutes = (): JSX.Element => {
  const flags = useFeatureFlag([
    'custom-away-status',
    'authorization-custom-role',
  ]);

  const hasManageWorkloadsAccess = useHasAccess('organization.workload');
  const hasManageRolesAccess = useHasAccess('organization.access');
  const hasCustomAwayStatusAccess = useHasAccess('settings.custom_away_status');

  return (
    <Routes>
      <Route path="*" element={<SettingsAgentsView />}>
        <Route index element={<SettingsAgentsListView />} />

        {hasManageWorkloadsAccess && (
          <Route path="workloads" element={<SettingsAgentsWorkloadsView />} />
        )}

        {hasManageRolesAccess && (
          <Route path="roles" element={<SettingsAgentsRolesView />} />
        )}

        {flags.customAwayStatus && hasCustomAwayStatusAccess && (
          <Route path="away-status" element={<SettingsAwayStatusView />} />
        )}

        <Route
          path="*"
          element={
            <NotFoundView navigatePath="/settings/agents" name="Agents" />
          }
        />
      </Route>

      {hasManageRolesAccess && (
        <>
          {flags.authorizationCustomRole && (
            <Route
              path="roles/create"
              element={<SettingsAgentsRolesCreateView />}
            />
          )}

          <Route
            path="roles/:roleType/:roleId"
            element={<SettingsAgentsRolesEditView />}
          >
            <Route index element={<Navigate to="permissions" />} />
            <Route
              path="permissions"
              element={<SettingsAgentsRolesEditPermissionsView />}
            />
            <Route
              path="agents"
              element={<SettingsAgentsRolesEditAgentsView />}
            />
          </Route>
        </>
      )}
    </Routes>
  );
};
